// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-radio-group {
  width: 100%;
  border-radius: 0px;
  padding: 5px;
  display: block;
}

.price {
  font-size: 14px;
  color: black;
  font-family: AppFontBold, sans-serif;
}

ion-label {
  font-size: 14px;
}
@media (min-width: 991px) {
  ion-label {
    padding-right: 5px;
  }
}

ion-icon {
  color: var(--ion-color-primary);
  height: 20px;
  width: 20px;
}

app-tag {
  display: inline-block;
}

ion-item {
  background: #FFFFFF;
  border-radius: 0px !important;
  margin: 10px 0px;
  --inner-padding-end: 2px;
}

.item-img {
  width: 50px;
  padding: 7px;
}

ion-checkbox::part(container) {
  border: none;
  background: url('add-plus.svg') no-repeat center center/100% 100%;
  background-size: contain;
}

ion-checkbox.checkbox-checked::part(container) {
  background: var(--ion-color-primary);
  border-color: transparent;
  border-radius: 50%;
}

.text_wrap {
  text-align: left;
  text-wrap: wrap;
  white-space: normal;
  word-break: break-word;
}
.text_wrap span {
  color: #1A1A18 !important;
  font-family: AppFont, sans-serif !important;
  display: flex;
}

.mehr-articles {
  width: -moz-fit-content;
  width: fit-content;
}
.mehr-articles div {
  background: white;
  border: 1px solid black;
  padding: 5px 10px;
  border-radius: 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.mehr-articles div h3 {
  margin-right: 20px;
}
.mehr-articles div ion-icon {
  color: black;
  margin-left: 15px;
  rotate: 0deg;
  transition: rotate 0.7s;
}
.mehr-articles div ion-icon.rotate {
  rotate: 180deg;
}

.content-only {
  vertical-align: bottom;
  height: 18px;
  width: 18px;
  padding: 0;
  margin-left: 3px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-checkbox/article-option-group-checkbox.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,YAAA;EACA,oCAAA;AADF;;AAIA;EACE,eAAA;AADF;ACdE;EDcF;IAGI,kBAAA;EACF;AACF;;AAEA;EACE,+BAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AACA;EACE,mBAAA;EACA,6BAAA;EACA,gBAAA;EACA,wBAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;AAEF;;AACA;EAEE,YAAA;EACA,iEAAA;EACA,wBAAA;AACF;;AAEA;EACE,oCAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AACF;AACE;EACE,yBAAA;EAEA,2CAAA;EACA,aAAA;AAAJ;;AAKA;EACE,uBAAA;EAAA,kBAAA;AAFF;AAGE;EACE,iBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADJ;AAEI;EACE,kBAAA;AAAN;AAEI;EACE,YAAA;EACA,iBAAA;EACA,YAAA;EACA,uBAAA;AAAN;AACM;EACE,cAAA;AACR;;AAKA;EACE,sBAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;AAFF","sourcesContent":["@import '../../../theme/mixins';\n\nion-radio-group {\n  width: 100%;\n  border-radius: 0px;\n  padding: 5px;\n  display: block;\n}\n\n.price {\n  font-size: 14px;\n  color: black;\n  font-family: AppFontBold, sans-serif;\n}\n\nion-label {\n  font-size: 14px;\n  @include desktop {\n    padding-right: 5px;\n  }\n}\n\nion-icon {\n  color: var(--ion-color-primary);\n  height: 20px;\n  width: 20px;\n}\n\napp-tag {\n  display: inline-block;\n}\nion-item{\n  background: #FFFFFF;\n  border-radius: 0px !important;\n  margin: 10px 0px;\n  --inner-padding-end: 2px;\n}\n\n.item-img {\n  width: 50px;\n  padding: 7px;\n}\n\nion-checkbox::part(container) {\n\n  border: none;\n  background: url('../../../assets/losteria/add-plus.svg') no-repeat center center/ 100% 100%;\n  background-size: contain;\n\n}\nion-checkbox.checkbox-checked::part(container) {\n  background: var(--ion-color-primary);\n  border-color: transparent;\n  border-radius: 50%;\n}\n\n.text_wrap {\n  text-align: left;\n  text-wrap: wrap;\n  white-space: normal;\n  word-break: break-word;\n  \n  span {\n    color: #1A1A18 !important;\n    \n    font-family: AppFont, sans-serif  !important;\n    display: flex;\n\n\n  }\n}\n.mehr-articles {\n  width: fit-content;\n  div {\n    background: white;\n    border: 1px solid black;\n    padding: 5px 10px;\n    border-radius: 25px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    h3 {\n      margin-right: 20px;\n    }\n    ion-icon {\n      color: black;\n      margin-left: 15px;\n      rotate: 0deg;\n      transition: rotate 0.7s ;\n      &.rotate {\n        rotate: 180deg;\n      }\n    }\n  }\n}\n\n.content-only {\n  vertical-align: bottom;\n  height: 18px;\n  width: 18px;\n  padding: 0;\n  margin-left: 3px;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
